export default "__VITE_ASSET__rmMxXFSu__"